/**
 * @author gyb(mocheer)
 * @email `mocheer@foxmail.com`  
 * @since 2017-6-15
 */
import {
  coattail
} from '@/utils/Bezier';
let {
  Polyline,
  Polygon,
  point: toPoint
} = L;
let {
  _projectLatlngs,
  toGeoJSON
} = Polyline.prototype
/**
 * 军标箭头
 * 
 *  在transofrom控件拖拽旋转中会报错
 */
export default L.MilitaryArrow = L.MilitaryArrow || Polyline.extend({
  /**
   * @param options
   */
  options: {
    fill: true,
    // noClip: true // 已重写 clipPoints
  },
  /**
   * @override
   */
  _projectLatlngs(latlngs, _rings, projectedBounds) {
    _projectLatlngs.call(this, latlngs, _rings, projectedBounds);
    let temp = this._rings;
    temp = temp[0].map(p => [p.x, p.y]);
    temp = coattail(temp, 0.005, this.options);
    let [result] = this._rings_temp = [
      []
    ];
    for (let i = 0, l = temp.length; i < l; i++) {
      result[i] = toPoint(temp[i][0], temp[i][1]);
      projectedBounds.extend(result[i]);
    }
  },
  /**
   * 重写
   */
  _clipPoints() {
    this._parts = this._rings_temp;
  },
  /**
   * 
   */
  _containsPoint(p) {
    return Polygon.prototype._containsPoint.call(this, p, true);
  },
  /**
   * 
   */
  toGeoJSON() {
    let json = toGeoJSON.call(this);
    json.geometry.type = 'MilitaryArrow'
    return json;
  }
})



// WEBPACK FOOTER //
// ./src/feature/MilitaryArrow.js